import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Retifica uma evolução geral: o backend corrige no lugar e guarda o antes/depois no histórico.
export function useRectifyGeneralEvolution() {
  const [isRectifying, setRectifying] = useState(false);

  const rectify = useCallback((evolutionId, rectification) => {
    setRectifying(true);
    return quarkusApi
      .put(`/paciente/evolucao/${evolutionId}/rectify`, rectification, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setRectifying(false));
  }, []);

  return { rectify, isRectifying };
}
